import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-container" }
const _hoisted_2 = { class: "pagination-total-records" }
const _hoisted_3 = { class: "pagination-paging-controls" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "pagination-paging-controls__current" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

import { ref, watch, onMounted } from 'vue';
import ChevronRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import SkipNext from 'vue-material-design-icons/SkipNext.vue';
import SkipPrevious from 'vue-material-design-icons/SkipPrevious.vue';

export interface Page {
  start: number;
  end: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PagingControl',
  props: {
  total: {
    type: Number,
    default: 0,
  },
  rowsPerPage: {
    type: Number,
    default: 50,
  },
  page: {
    type: Number,
    default: 1,
  },
  disableControls: {
    type: Boolean,
    default: false,
  },
},
  emits: ["page-changed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const currentPage = ref(1);
const totalRows = ref(0);

onMounted(() => {
  currentPage.value = props.page || 1;
  totalRows.value = props.total || 0;
});

watch(
  () => props.total,
  (current, previous) => {
    totalRows.value = current;

    if (totalRows.value < 0) {
      totalRows.value = 0;
    }

    // if new total means that our current page is invalid, then reset back to the first page
    if (currentPage.value > 1 && isPageOutOfBounds(currentPage.value)) {
      currentPage.value = 1;
      pageChanged();
    }
  },
);

function numberOfPages() {
  if (totalRows.value <= 0) {
    return 1;
  }

  return Math.max(Math.ceil(totalRows.value / props.rowsPerPage), 1);
}

function last() {
  if (props.disableControls) {
    return;
  }

  if (hasNext()) {
    currentPage.value = numberOfPages();
    pageChanged();
  }
}

function first() {
  if (props.disableControls) {
    return;
  }

  if (hasPrevious()) {
    currentPage.value = 1;
    pageChanged();
  }
}

function next() {
  if (props.disableControls) {
    return;
  }

  if (hasNext()) {
    currentPage.value++;
    pageChanged();
  }
}

function previous() {
  if (props.disableControls) {
    return;
  }

  if (hasPrevious()) {
    currentPage.value--;
    pageChanged();
  }
}

function hasNext() {
  const next = currentPage.value + 1;
  return !isPageOutOfBounds(next);
}

function hasPrevious() {
  return currentPage.value > 1;
}

function startOfPage(pageNumber?: number): number {
  // default to current page if page number not supplied
  pageNumber = typeof pageNumber !== 'undefined' ? pageNumber : currentPage.value;
  return (pageNumber - 1) * props.rowsPerPage + 1;
}

function endOfPage(pageNumber?: number): number {
  // default to current page if page number not supplied
  pageNumber = typeof pageNumber !== 'undefined' ? pageNumber : currentPage.value;
  return Math.min(pageNumber * props.rowsPerPage, totalRows.value);
}

const emit = __emit;

function pageChanged() {
  // our rows are 1-based, but consumers of this will likely have their records stored in 0-based arrays
  emit('page-changed', {
    start: startOfPage() - 1,
    end: endOfPage(),
  });
}

function isPageOutOfBounds(pageNumber: number): boolean {
  return startOfPage(pageNumber) > totalRows.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(totalRows.value) + " records", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "action",
        disabled: !hasPrevious() || __props.disableControls,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (first()))
      }, [
        _createVNode(SkipPrevious)
      ], 8, _hoisted_4),
      _cache[4] || (_cache[4] = _createTextVNode("   ", -1)),
      _createElementVNode("div", {
        class: "action",
        disabled: !hasPrevious() || __props.disableControls,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (previous()))
      }, [
        _createVNode(ChevronLeft)
      ], 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, "Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(numberOfPages()), 1),
      _createElementVNode("div", {
        class: "action",
        disabled: !hasNext() || __props.disableControls,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (next()))
      }, [
        _createVNode(ChevronRight)
      ], 8, _hoisted_7),
      _cache[5] || (_cache[5] = _createTextVNode("   ", -1)),
      _createElementVNode("div", {
        class: "action",
        disabled: !hasNext() || __props.disableControls,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (last()))
      }, [
        _createVNode(SkipNext)
      ], 8, _hoisted_8)
    ])
  ]))
}
}

})